// InventoryAdminInventory - Global Cash Flow Component
import React, { useState } from 'react';
import '../../../../assests/css/admin/Analytics/GlobalCashFlow/GlobalCashFlow.css';

const GlobalCashFlow = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Cash flow data for 15 periods (matching your image)
  const cashFlowData = [
    { period: '1', month: 15, week: 8 },
    { period: '2', month: 13, week: 7 },
    { period: '3', month: 18, week: 10 },
    { period: '4', month: 20, week: 12 },
    { period: '5', month: 15, week: 8 },
    { period: '6', month: 17, week: 9 },
    { period: '7', month: 16, week: 8 },
    { period: '8', month: 18, week: 10 },
    { period: '9', month: 20, week: 11 },
    { period: '10', month: 17, week: 9 },
    { period: '11', month: 23, week: 12 },
    { period: '12', month: 16, week: 8 },
    { period: '13', month: 21, week: 11 },
    { period: '14', month: 19, week: 13 },
    { period: '15', month: 20, week: 11 },
  ];

  const maxValue = 35; // Maximum value for scaling

  return (
    <div className="InventoryAdminInventory-global-cashflow">
      <div className="InventoryAdminInventory-cashflow-header">
        <div>
          <div className="InventoryAdminInventory-cashflow-title">
            CASH FLOW
          </div>
        </div>
        <div className="InventoryAdminInventory-cashflow-more">
          <span>•••</span>
        </div>
      </div>

      <div className="InventoryAdminInventory-chart-wrapper">
        <div className="InventoryAdminInventory-y-axis-cashflow">
          <span className="InventoryAdminInventory-y-label-cashflow">30k</span>
          <span className="InventoryAdminInventory-y-label-cashflow">20k</span>
          <span className="InventoryAdminInventory-y-label-cashflow">10k</span>
          <span className="InventoryAdminInventory-y-label-cashflow">0</span>
          <span className="InventoryAdminInventory-y-label-cashflow">-10k</span>
          <span className="InventoryAdminInventory-y-label-cashflow">-20k</span>
          <span className="InventoryAdminInventory-y-label-cashflow">-30k</span>
        </div>

        <div className="InventoryAdminInventory-chart-content">
          <div className="InventoryAdminInventory-zero-line"></div>
          
          <div className="InventoryAdminInventory-bars-wrapper">
            {cashFlowData.map((data, index) => {
              const monthHeight = (data.month / maxValue) * 100;
              const weekHeight = (data.week / maxValue) * 100;
              
              return (
                <div 
                  key={index} 
                  className="InventoryAdminInventory-chart-column"
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <div className="InventoryAdminInventory-stacked-bars">
                    {/* Month bar (cyan/turquoise) */}
                    <div 
                      className="InventoryAdminInventory-bar-stack month"
                      style={{ 
                        height: `${monthHeight}%`,
                        animationDelay: `${0.3 + index * 0.05}s`
                      }}
                    >
                      {hoveredIndex === index && (
                        <div className="InventoryAdminInventory-bar-tooltip">
                          {data.month}k
                        </div>
                      )}
                    </div>
                    
                    {/* Week bar (dark blue/purple) */}
                    <div 
                      className="InventoryAdminInventory-bar-stack week"
                      style={{ 
                        height: `${weekHeight}%`,
                        animationDelay: `${0.4 + index * 0.05}s`
                      }}
                    >
                      {hoveredIndex === index && (
                        <div className="InventoryAdminInventory-bar-tooltip">
                          {data.week}k
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="InventoryAdminInventory-period-label">
                    {data.period}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="InventoryAdminInventory-cashflow-legend">
        <div className="InventoryAdminInventory-cashflow-legend-item">
          <div className="InventoryAdminInventory-legend-indicator week"></div>
          <span className="InventoryAdminInventory-legend-label">WEEK</span>
        </div>
        <div className="InventoryAdminInventory-cashflow-legend-item">
          <div className="InventoryAdminInventory-legend-indicator month"></div>
          <span className="InventoryAdminInventory-legend-label">MONTH</span>
        </div>
      </div>
    </div>
  );
};

export default GlobalCashFlow;